import { SharedObject } from './../../../shared/sharedObject';
import { ActiveOldUser } from './../../models/activeOldUserModel';
import { PurchaseService } from './../../services/purchase.service';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NewCodeGeneratedModel } from '../../models/newCodeGeneratedModel';
import { ClipboardService } from 'ngx-clipboard';
import { MatSnackBar } from '@angular/material';
import moment, { duration } from 'jalali-moment';

@Component({
  selector: 'app-renew',
  templateUrl: './renew.component.html',
  styleUrls: ['./renew.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenewComponent implements OnInit {
  dataForm: FormGroup;
  loading: boolean = false;
  success: boolean = false;
  message: string = null;
  newCodeGeneratedModel: NewCodeGeneratedModel;
  totalDay: number;
  totalMonth: number;
  totalYear: number;
  packageTime: string = "";
  constructor(private fb: FormBuilder,
    private purchaseService: PurchaseService,
    private changeDetectorRef: ChangeDetectorRef,
    private clipboardService: ClipboardService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.initLoginForm();
  }

  initLoginForm() {
    this.dataForm = this.fb.group({
      mobileNumber: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(SharedObject.MobilePattern)
        ])
      ],
      userName: [
        "",
        Validators.compose([
          Validators.required
        ])
      ],
      password: [
        "",
        Validators.compose([
          Validators.required
        ])
      ]
    });
  }
  submitForm() {
    const controls = this.dataForm.controls;
    /** check form */
    if (this.dataForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    var model = new ActiveOldUser();
    model.userName = controls['userName'].value;
    model.phoneNumber = controls['mobileNumber'].value;
    model.password = controls['password'].value;
    this.purchaseService.activeOldUser(model).subscribe((res: NewCodeGeneratedModel) => {
      this.loading = false;
      this.success = true;
      moment.duration()
      this.newCodeGeneratedModel = res;
      res.durationInDays = res.durationInDays - 62;
      var mom = moment.duration(res.durationInDays, 'days');
      if (mom.years() > 0)
        this.packageTime = `${mom.years()} سال و `;
      if (mom.months() > 0)
        this.packageTime += `${mom.months()} ماه و `;
      if (mom.days() > 0)
        this.packageTime += `${mom.days()} روز `;
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.loading = false;
      this.message = `خطا ${err.error['result']}`;
      this.changeDetectorRef.markForCheck();
    }, () => {
      this.changeDetectorRef.markForCheck();
    });
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.dataForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  copyCode(code: string) {
    if (code == null) return;

    this.clipboardService.copyFromContent(code);
    this.snackBar.open("با موفقیت کپی شد", null, {
      duration: 2000,
    });
  }
}
